import React, { useState } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import FarmerMasterDocument from "./FarmerMasterDocument";
import { Row, Form, Col, FormControl, Button } from "react-bootstrap";
import farmerMasterService from "../../services/farmermaster.service";
import { toast } from "react-toastify";
import apihostname from "../../services/apihostname";

// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";

moment.locale("th");

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

// Create Document Component
function PrintPdfMaster() {
  const [personcard, setPersoncard] = useState("");
  const [hidden, setHidden] = useState(true);
  const [farmer, setFarmer] = useState({});
  const [loading, setLoading] = useState(false);

  const handleClick = (e) => {
    setHidden(true);
    e.preventDefault();
    setLoading(true);
    farmerMasterService
      .getRegsugarIsFarmerMaster(personcard)
      .then((res) => {
        if (res.data.success) {
          setFarmer(res.data.data);
          setHidden(false);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <Row>
        <Col md={4}>
          <Form.Group>
            <FormControl
              placeholder="เลขบัตรประชาชน"
              type="number"
              name="person_card"
              onChange={(e) => setPersoncard(e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Button
              className="btn btn-primary"
              style={{
                padding: ".375rem .75rem",
                fontSize: "1rem",
                margin: "0",
              }}
              onClick={handleClick}
            >
              ค้นหา
            </Button>
          </Form.Group>
        </Col>
      </Row>
      <hr />
      <Row>
        {hidden ? (
          ""
        ) : (
          <div>
            <img
              src={apihostname + "/images/farmer/" + farmer.farmer_image}
              alt="No Image"
              width="150"
              height="150"
            />
            <br />
            <br />
            <p>
              รหัสประจำตัวชาวไร่อ้อย : <span>{farmer.farmer_card}</span>
            </p>
            <p>
              เลขบัตรประชาชน : <span>{farmer.masteridcard}</span>
            </p>
            <p>
              ชื่อ - สกุล : <span>{farmer.mastername}</span>
            </p>
            <p>
              เพศ : <span>{farmer.farmer_gender}</span>
            </p>
            <p>
              วันเกิด :{" "}
              <span>
                {moment(farmer.farmer_birthday)
                  .add(543, "year")
                  .locale("th")
                  .format("ll")}
              </span>
            </p>
            <p>
              เบอร์โทรศัพท์ : <span>{farmer.farmer_phone}</span>
            </p>
            <p>
              ที่อยู่ : <span>{farmer.address}</span>
            </p>

            <p>
              วันที่เริ่มต้น :{" "}
              <span>
                {moment(farmer.start_date)
                  .add(543, "year")
                  .locale("th")
                  .format("ll")}
              </span>
            </p>
            <p>
              ผู้อนุมัติ : <span>{farmer.approve_name}</span>
            </p>
            <PDFDownloadLink
              document={<FarmerMasterDocument farmer={farmer} />}
              fileName={"บัตรหัวหน้ากลุ่ม-" + farmer.mastername + ".pdf"}
            >
              {({ blob, url, loading, error }) => {
                console.log(blob, url, error);
                return loading ? (
                  "Loading document..."
                ) : (
                  <button className="btn btn-primary">
                    <i className="bi bi-printer"> Print Now!</i>
                  </button>
                );
              }}
            </PDFDownloadLink>
          </div>
        )}
      </Row>
    </>
  );
}
export default PrintPdfMaster;
